import React, { useEffect, useState } from 'react';

const Error = ({ message }) => {
    const [errorMessage, setErrorMessage] = useState(undefined);

    useEffect(() => {
        setErrorMessage(message);
        if (message && message.length) {
            const focusEl = document.querySelector('#clx-step__error-summary');
            if (focusEl) {
                focusEl.scrollTop = focusEl.scrollHeight;
                focusEl.focus();
            }
        }
    }, [message]);

    return errorMessage ? (
        <p
            id="clx-step__error-summary"
            className={errorMessage ? 'visible' : ''}
            tabIndex={!errorMessage ? -1 : 0}
            data-test-id="clx-step__error"
        >
            {errorMessage}
        </p>
    ) : (
        <></>
    );
};

export default Error;
